import { useContext, useEffect, useState } from 'react';
import './cards.css';
import { CiImageOff } from 'react-icons/ci';
import AuthProvider from '../../contexts/auth'

export default function Cards() {
    const [machines, setMachines] = useState([]);
    const [fetchCompleted, setFetchCompleted] = useState(false);
    const auth = useContext(AuthProvider)

    useEffect(() => {
        const fetchData = () => {
            fetch('https://gipapi.azurewebsites.net/Planejamento/Recursos', {
            //fetch('https://localhost:44303/Planejamento/Recursos', { 
                method: "GET",
                headers: {
                    'access_token': auth.user
                }
            })
                .then(response => response.json())
                .then(json => {
                    setMachines(json);
                    setFetchCompleted(true); // Indica que o fetch foi concluído
                    console.log(json);
                })
                .catch(error => {
                    console.error('Erro ao buscar máquinas:', error);
                });
        };

        // Chamar fetchData() uma vez quando o componente montar
        fetchData();

        // Chamar fetchData() a cada 1 minuto
        const interval = setInterval(fetchData, 30000);

        // Limpar intervalo quando o componente desmontar
        return () => clearInterval(interval);
    }, [auth.user]);

    // Verifica se o fetch foi concluído antes de renderizar o componente
    if (!fetchCompleted) {
        return <div>Carregando...</div>;
    }

    // Verificação de nulidade e se é uma matriz antes de chamar map()
    if (!machines || !Array.isArray(machines) || machines.length === 0) {
        return <div>Nenhuma máquina disponível.</div>;
    }

    return (
        <div className="globalCardsContainer">
            {machines.map((machine, index) => (
                <div className='containerCard' key={'machine' + index}>
                    <div className='machineName'>{machine?.NomeMaquina}</div>
                    <div className='machineImg'>
                        {machine?.Imagem ? (
                            <div className='containerMachineImg'>
                                <img src={`data:image/jpeg;base64,${machine?.Imagem}`} alt="Imagem da máquina" />
                            </div>
                        ) : (
                            <div className='containerMissingImageCard'>
                                <div className='disclaimerMissingImageCard'>Sem imagem cadastrada</div>
                                <div className='containerIconMissingImageCard'>
                                    <CiImageOff size={50} />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='machineStatus' style={{ color: machine?.StatusMaq === "PARADA" ? "red" : "green" }}>{machine?.StatusMaq}</div>
                    <div className='machineTime'>
                        há {machine?.TempoMaqStr}
                    </div>
                    <div className='machineDetail'>
                        <div className='machineField'>OEE (hoje): </div>
                        <div className='machineOEEValue'>{machine?.OEE.toString().match(/^\d+(?:\.\d{0,2})?/)}%</div>
                    </div>
                    <div className='machineDetailFlex'>
                        <div className='machineField'>OS: </div>
                        <div className='machineField'>{machine?.Os}</div>
                        <div className='machineField'>Pos: </div>
                        <div className='machineField'>{machine?.Posicao?.split(" ").pop().replace(/[A-Za-z]/g, "")}</div>
                    </div>
                    <div className='machineDetailFlex'>
                        <div className='machineField'>Tempo: </div>
                        <div className='machineField'>{machine?.PlanejadoStr}</div>
                        <div className='machineField'>Plan / </div>
                        <div className='machineField'>{machine?.RealizadoStr}</div>
                        <div className='machineField'>Real</div>
                    </div>
                </div>
            ))}
        </div>
    );
}